import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import ElaborateQuestion from './ElaborateQuestion';
import { useHistory } from 'react-router';
import submitResponse from '../../services/submitResponse';
import publicIp from 'react-public-ip';
import { FormattedMessage, useIntl } from 'react-intl';
import { language, submitMessage } from '../../language';
import axiosInterceptor from '../../services/axiosInterceptor';

const surveyObject_en = {
    name: 'Optional Survey 1',
    pages: [
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Please list five examples of things that are <span style="font-weight: bold;">morally bad</span> or <span style="font-weight: bold;">wrong</span>. Think of either<span style="font-weight: bold;"> actions by individuals or of social or political issues</span>.</p>',
            rankTitle:
                'Please rank the examples so that the most wrong or bad example appears at the top and the least wrong or bad examples appears at the bottom of the list.',
            elaborateTitle:
                'Please elaborate on the example and, in your own words, explain why it is morally bad or wrong. Write at least 100 words.',
            name: 'morally_bad'
        },
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Please list five examples of things that are <span style="font-weight: bold;">morally good</span> or <span style="font-weight: bold;">right</span>. Think of either<span style="font-weight: bold;"> actions by individuals or of social or political issues</span>.</p>',
            rankTitle:
                'Please rank the examples so that the most good or right example appears at the top and the least good or right examples appears at the bottom of the list.',
            elaborateTitle:
                'Please elaborate on the example and, in your own words, explain why it is morally good or right. Write at least 100 words.',
            name: 'morally_good'
        },
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Please list five <span style="font-weight: bold;">people or groups that you despise</span> because they did or are doing something <span style="font-weight: bold;">morally bad</span> or <span style="font-weight: bold;">wrong</span>.</p>',
            rankTitle:
                'Please rank the examples so that the person or group you despise the most appears at the top and the person or group you despise the least appears at the bottom of the list.',
            elaborateTitle:
                'Please elaborate on the example and, in your own words, explain why you despise that person or group. Write at least 100 words.',
            name: 'people_despise'
        },
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Please list five <span style="font-weight: bold;">people or groups that you admire</span> because they did or are doing something <span style="font-weight: bold;">morally good</span> or <span style="font-weight: bold;">right</span>.</p>',
            rankTitle:
                'Please rank the examples so that the person or group you admire the most appears at the top and the person or group you admire the least appears at the bottom of the list.',
            elaborateTitle:
                'Please elaborate on the example and, in your own words, explain why you admire that person or group. Write at least 100 words.',
            name: 'people_admire'
        }
    ]
};

const surveyObject_fr = {
    name: 'Optional Survey 1',
    pages: [
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Énumérez cinq exemples de choses qui sont <span style="font-weight: bold;">moralement mauvaises</span>. Pensez à des <span style="font-weight: bold;">actions individuelles</span> ou à des <span style="font-weight: bold;">problèmes sociaux ou politiques</span>.</p>',
            rankTitle:
                'Veuillez classer les exemples de sorte que le plus mauvais apparaisse en haut de la liste et le moins mauvais en bas.',
            elaborateTitle:
                'Veuillez développer l’exemple et, dans vos propres mots, expliquer pourquoi il est moralement mauvais. Veuillez écrire au moins 100 mots.',
            name: 'morally_bad'
        },
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Énumérez cinq exemples de choses <span style="font-weight: bold;">moralement bonnes</span> ou <span style="font-weight: bold;">justes</span>. Pensez à des <span style="font-weight: bold;">actions individuelles</span> ou à des <span style="font-weight: bold;">problèmes sociaux ou politiques</span>.</p>',
            rankTitle:
                'Veuillez classer les exemples de sorte que le meilleur apparaisse en haut de la liste et le moins bon en bas.',
            elaborateTitle:
                'Veuillez développer l’exemple et, dans vos propres mots, expliquer pourquoi il est moralement bon ou juste. Veuillez écrire au moins 100 mots.',
            name: 'morally_good'
        },
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Veuillez énumérer cinq  <span style="font-weight: bold;">personnes</span> ou  <span style="font-weight: bold;">groupes de personnes</span> que vous méprisez parce qu’ils font ou ont fait quelque chose de  <span style="font-weight: bold;">moralement mauvais</span>.</p>',
            rankTitle:
                'Veuillez classer les exemples de sorte que la personne ou le groupe de personnes que vous méprisez le plus apparaisse en haut et que la personne ou le groupe de personnes que vous méprisez le moins apparaisse en bas de la liste.',
            elaborateTitle:
                'Veuillez développer l’exemple et, dans vos propres mots, expliquer pourquoi vous méprisez cette personne ou ce groupe de personnes. Veuillez écrire au moins 100 mots.',
            name: 'people_despise'
        },
        {
            numberOfElatorations: 5,
            listTitle:
                '<p>Veuillez énumérer cinq <span style="font-weight: bold;">personnes</span> ou <span style="font-weight: bold;">groupes de personnes</span> que vous admirez parce qu’ils ont fait ou font quelque chose de <span style="font-weight: bold;">moralement bon ou juste</span>.</p>',
            rankTitle:
                'Veuillez classer les exemples de sorte que la personne ou le groupe de personnes que vous admirez le plus apparaisse en haut et que la personne ou le groupe de personnes que vous admirez le moins apparaisse en bas de la liste.',
            elaborateTitle:
                'Veuillez développer l’exemple et, dans vos propres mots, expliquer pourquoi vous admirez cette personne ou ce groupe. Veuillez écrire au moins 100 mots.',
            name: 'people_admire'
        }
    ]
};
const surveyObject = language === 'fr' ? surveyObject_fr : surveyObject_en;

const ElaborateSurvey = () => {
    const history = useHistory();
    const [currentQuestion, setCurrentQuestion] = useState(
        surveyObject.pages[0]
    );
    const [currentResult, setCurrentResult] = useState([]);
    const [elaboration, setElaboration] = useState('');
    const [random, setRandom] = useState(Math.floor(Math.random() * 5));
    const [results, setResults] = useState([]);
    const [index, setIndex] = useState(0);
    const [ip, setIp] = useState(null);
    const [startTime, setStartTime] = useState(Date.now());
    const [page, setPage] = useState(0);
    const [disabled, setDisabled] = useState(false);

    const intl = useIntl();

    const resetCurrentResult = useCallback(() => {
        setCurrentResult(['', '', '', '', '']);
        setElaboration('');
        setRandom(Math.floor(Math.random() * 5));
    }, []);

    useEffect(() => {
        const checkConsent = async () => {
            try {
                const response = await axiosInterceptor().get(
                    'incas/consentAccepted'
                );
                if (!response.data.consentAccepted) {
                    history.push('/consent');
                }
            } catch (e) {
                console.log(e);
                history.push('/consent');
            }
        };
        checkConsent();
        const setInitialStates = async () => {
            try {
                const ipv4 = (await publicIp.v4()) || '';
                setIp(ipv4);
            } catch (err) {}
            setStartTime(Date.now());
        };
        setInitialStates();
    }, []);

    useEffect(() => {
        resetCurrentResult();
    }, [results]);

    useEffect(() => {
        setCurrentQuestion(surveyObject.pages[index]);
    }, [index]);

    const getButtons = useCallback(() => {
        return (
            <Container>
                <Row>
                    <Col>
                        {index < surveyObject.pages.length - 1
                            ? page >= 2 && (
                                  <Row>
                                      <Col xs={7} className="text-left">
                                          <FormattedMessage
                                              id="Elaborate.instructionNext"
                                              defaultMessage="(Click on Next to go to the next question)"
                                          />
                                      </Col>
                                      <Col>
                                          <Button
                                              className="w-100"
                                              variant="outline-warning"
                                              disabled={
                                                  index >=
                                                  surveyObject.pages.length - 1
                                              }
                                              onClick={() => {
                                                  setIndex((old) => old + 1);
                                                  setResults((oldResults) => {
                                                      const newResults = [
                                                          ...oldResults
                                                      ];
                                                      newResults.push({
                                                          items: currentResult,
                                                          elaborationItem:
                                                              currentResult[
                                                                  random
                                                              ],
                                                          elaborationContent:
                                                              elaboration
                                                      });
                                                      return newResults;
                                                  });
                                              }}
                                          >
                                              <FormattedMessage
                                                  id="Elaborate.nextQuestion"
                                                  defaultMessage="Next Question"
                                              />
                                          </Button>
                                      </Col>
                                  </Row>
                              )
                            : page >= 2 && (
                                  <Button
                                      variant="outline-warning"
                                      disabled={disabled}
                                      onClick={() => {
                                          setDisabled(true);
                                          const newResults = [...results];
                                          newResults.push({
                                              items: currentResult,
                                              elaborationItem:
                                                  currentResult[random],
                                              elaborationContent: elaboration
                                          });
                                          submitResponse(
                                              newResults,
                                              history,
                                              'elaborate',
                                              ip,
                                              startTime,
                                              intl.formatMessage(
                                                  submitMessage.submitted
                                              ),
                                              true
                                          );
                                      }}
                                  >
                                      <FormattedMessage
                                          id="Elaborate.completeAndSubmit"
                                          defaultMessage="Complete and Submit"
                                      />
                                  </Button>
                              )}
                    </Col>
                </Row>
            </Container>
        );
    }, [index, currentResult, elaboration, page, disabled]);

    useEffect(() => {
        resetCurrentResult();
    }, []);

    return (
        <Container>
            <Row>
                <Col className="h2 mb-3">{surveyObject.name}</Col>
            </Row>
            <ElaborateQuestion
                question={currentQuestion}
                result={currentResult}
                setResult={setCurrentResult}
                elaboration={elaboration}
                setElaboration={setElaboration}
                random={random}
                page={page}
                setPage={setPage}
            />

            <Row className="mt-4">
                <Col>{getButtons()}</Col>
            </Row>
        </Container>
    );
};

export default ElaborateSurvey;
